import { allTeamMembersSortableByLastName } from '../../../graphql/custom_queries';
import PropTypes from 'prop-types';
import { generateClient } from "aws-amplify/api";
const client = generateClient();

// export const listAllTeamMembers = async (nextoken, limit=250) => {
//   try {
//     let gqlParams = {}
//     if (nextoken!==undefined && nextoken!=='') {
//       gqlParams = {
//         allSort: "all",
//         sortDirection: 'ASC',
//         limit: limit,
//         nextToken: nextoken
//       }
//     } else {
//       gqlParams = {
//         allSort: "all",
//         sortDirection: 'ASC',
//         limit: limit
//       }
//     }

//     const response = await client
//     .graphql({
//       query: allTeamMembersSortableByLastName,
//       variables: gqlParams
//     })
    
//     const results = response.data.allTeamMembersSortableByLastName

//     return results;
//   } catch (err) {
//     return('listAllTeamMembers error: ', [err]);
//   }

// }

export const listAllTeamMembers = async (nextoken, limit = 250, includeInactive = false) => {
  try {
    let gqlParams = {}
    if (nextoken !== undefined && nextoken !== '') {
      gqlParams = { allSort: "all", sortDirection: 'ASC', limit, nextToken: nextoken }
    } else {
      gqlParams = { allSort: "all", sortDirection: 'ASC', limit }
    }

    const response = await client.graphql({
      query: allTeamMembersSortableByLastName,
      variables: gqlParams
    })

    const data = response.data.allTeamMembersSortableByLastName

    // Default: active-only. Admin Team Members passes includeInactive=true
    // so its "Show Inactive" toggle still works.
    if (includeInactive) return data
    return { items: data.items.filter(item => item.isActive), nextToken: data.nextToken }
  } catch (err) {
    return('listAllTeamMembers error: ', [err]);
  }
}

listAllTeamMembers.propTypes = {
  nextToken: PropTypes.string.isRequired,
  limit: PropTypes.string.isRequired,
};